/**
 * Calculate a relative time value and unit for use with Intl.RelativeTimeFormat
 * or react-intl's FormattedRelativeTime.
 */
export function getRelativeTimeValue(date: Date): {
  value: number;
  unit: Intl.RelativeTimeFormatUnit;
} {
  const now = new Date();
  const diffInSeconds = (date.getTime() - now.getTime()) / 1000;

  const absDiff = Math.abs(diffInSeconds);

  if (absDiff < 60) {
    return { value: Math.round(diffInSeconds), unit: 'second' };
  } else if (absDiff < 3600) {
    return { value: Math.round(diffInSeconds / 60), unit: 'minute' };
  } else if (absDiff < 86400) {
    return { value: Math.round(diffInSeconds / 3600), unit: 'hour' };
  } else if (absDiff < 604800) {
    return { value: Math.round(diffInSeconds / 86400), unit: 'day' };
  } else if (absDiff < 2592000) {
    return { value: Math.round(diffInSeconds / 604800), unit: 'week' };
  } else if (absDiff < 31536000) {
    return { value: Math.round(diffInSeconds / 2592000), unit: 'month' };
  } else {
    return { value: Math.round(diffInSeconds / 31536000), unit: 'year' };
  }
}
